import type { FaultReportShape } from 'Services/SalesManagement/Features/FaultReport/faultReportSlice'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { datetimeFormatter } from 'Util/formatters'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import EditIcon from '@mui/icons-material/Edit'
import { Box, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { FC } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'ttag'

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main
}))

const FaultReport: FC<{
  faultReport: FaultReportShape
  handleEditClick: () => void
  canControl: boolean
}> = ({ faultReport, handleEditClick, canControl }) => {
  return (
    <Box display="flex" justifyContent="space-between" mb={2}>
      <Box display="flex" alignItems="flex-start">
        <ChevronRightIcon sx={theme => ({ color: theme.palette.tertiary.main })} />
        <Box display="flex" flexDirection="column">
          <StyledLink to={`${SALES_MANAGEMENT_ROOT_URL}/fault-reports/view/${faultReport.id}/`}>
            <Typography variant="h6" fontWeight={600}>
              {faultReport.title_fi}
            </Typography>
          </StyledLink>
          <Typography
            sx={{ opacity: 0.6 }}
            component="span"
            variant="body2"
            color="text.primary"
            mt={0.5}
            mb={1}
          >
            {t`Updated`}: {datetimeFormatter(faultReport.updated)}
          </Typography>
        </Box>
      </Box>
      {canControl && (
        <Box display="flex" alignItems="flex-start">
          <IconButton onClick={handleEditClick} aria-label={t`Edit fault report`}>
            <EditIcon sx={theme => ({ color: theme.palette.tertiary.main })} />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}

export { FaultReport }
